import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Home } from "./Home/Home.tsx";
import { Finishes } from "./Finishes/Finishes.tsx";
import { Gallery } from "./Gallery/Gallery.tsx";
import { ContactUs } from "./ContactUs/ContactUs.tsx";
import { Navigation } from "../components/Navigation/Navigation.tsx";
import { Footer } from "../components/Navigation/Footer.tsx";
import { ScrollUtils } from "../utils/ScrollUtils.tsx";

export default function PageRoutes() {
  return (
    <BrowserRouter>
      <Navigation />

      <div className="page-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/finishes" element={<Finishes />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact-us" element={<ContactUs />} />
        </Routes>

        <Footer />
      </div>

      <ScrollUtils />
    </BrowserRouter>
  );
}
